// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"e5e09361","715":"30db9176","768":"b3625680"}[chunkId] + ".chunk.js";
};